/**
 * Parse the value of an HTML property, casting boolean-like values as booleans.
 * For pure booleans, Stencil does this automatically, but not for mixed values like `boolean | string`.
 */
export const parseSpecialBooleanProp = <T>(value: T) => {
	// Parse values treated as true
	if (value === 'true' || value === '') return true;

	// Parse values treated as false
	if (value === 'false' || value === undefined) return false;

	// Leave all other values as they are
	return value;
};

/**
 * Parse the value of an HTML property, casting boolean-like values as booleans.
 * For pure booleans, Stencil does this automatically, but not for mixed values like `boolean | string`.
 */
export const parseSpecialTrueProp = <T>(value: T) => {
	// Parse values treated as true
	if (value === 'true' || value === '') return true;

	// Leave all other values as they are
	return value;
};

/**
 * Parse the value of an HTML property, casting boolean-like values as booleans.
 * For pure booleans, Stencil does this automatically, but not for mixed values like `boolean | string`.
 */
export const parseSpecialFalseProp = <T>(value: T) => {
	// Parse values treated as false
	if (value === 'false' || value === undefined) return false;

	// Leave all other values as they are
	return value;
};
